import { render, staticRenderFns } from "./Bind-mobile-number.vue?vue&type=template&id=9274c1ae&"
import script from "./Bind-mobile-number.vue?vue&type=script&lang=js&"
export * from "./Bind-mobile-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports